(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/NestedModel', 'services/kioskUserExtService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var kioskUserExtService = require('./../urls').kioskUserExtService;
    module.exports = factory(require('backbone-torso/modules/NestedModel'), kioskUserExtService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoNestedModel, kioskUserExtService) {
  'use strict';

  /**
   * Model for user information. Uses the KioskUserExtService and corresponds to a UserDTO (may be implemented as PortalUserDTO).
   *
   * @class UserModel
   * @extends Torso.NestedModel
   * @constructor
   */
  return TorsoNestedModel.extend({
    idAttribute: 'username',
    urlRoot: kioskUserExtService
  });
}));
